@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

.address {
  display: flex;
  flex-direction: column;
  width: $address-width;
  color: $address-color;
  font-family: $address-font-family;
  font-size: $address-font-size;
  font-weight: $address-font-weight;
  line-height: $address-line-height;
  padding-top: $address-padding-top;
  padding-right: $address-padding-right;
  padding-bottom: $address-padding-bottom;
  padding-left: $address-padding-left;
  margin-top: $address-margin-top;
  margin-right: $address-margin-right;
  margin-bottom: $address-margin-bottom;
  margin-left: $address-margin-left;
}

.title {
  color: $address-title-color;
  font-family: $address-title-font-family;
  font-size: $address-title-font-size;
  font-weight: $address-title-font-weight;
  line-height: $address-title-line-height;
  margin-bottom: $address-title-margin-bottom;
}

.form-element {
  width: $address-form-element-width;
  margin-top: $address-form-element-margin-top;
  margin-right: $address-form-element-margin-right;
  margin-bottom: $address-form-element-margin-bottom;
  margin-left: $address-form-element-margin-left;

  &:last-child {
    margin-bottom: 0;
  }
}

.map {
  display: $address-map-display;
  height: $address-map-height;
  width: $address-map-width;
  margin-top: $address-map-margin-top;
  margin-right: $address-map-margin-right;
  margin-bottom: $address-map-margin-bottom;
  margin-left: $address-map-margin-left;
  border-radius: $address-map-border-radius;
  position: relative;
  overflow: hidden;
}

.link {
  margin-top: $address-link-margin-top;
  margin-right: $address-link-margin-right;
  margin-bottom: $address-link-margin-bottom;
  margin-left: $address-link-margin-left;
  text-decoration: $address-link-text-decoration;
  color: $address-link-color;
  cursor: pointer;

  &:hover {
    color: $address-link-hover-color;
  }

  &:focus {
    color: $address-link-focus-color;
  }
}

.status {
  margin-top: $address-status-margin-top;

  &.error {
    color: $address-status-error-color;
  }

  &.success {
    color: $address-status-success-color;
  }
}

@media (max-width: $breakpoint-mobile) {
  .address {
    width: $mobile-address-width;
  }
}
